import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as elementStyles from "@universityofmaryland/web-styles-library/element";
import * as Styles from "@universityofmaryland/web-styles-library";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/styles";
import "../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../atomic/assets/image/background.js";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "../../atomic/layout/block/stacked.js";
import "../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import { createTextLockupLarge } from "../../atomic/text-lockup/large.js";
import "../../atomic/text-lockup/small.js";
const getBackgroundColor = (props) => {
  const { isThemeDark, isThemeMaryland, isThemeLight } = props;
  if (isThemeDark) return token.color.black;
  if (isThemeMaryland) return token.color.red;
  if (isThemeLight) return token.color.gray.lightest;
  return token.color.white;
};
const createAsset = ({ image }) => {
  if (!image) return null;
  return new ElementBuilder().withClassName("umd-hero-logo__asset").withChild(
    createImageBackground({
      element: image,
      isScaled: false,
      imageLoading: "eager",
      imageFetchPriority: "high"
    })
  ).withStyles({
    element: {
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      maxWidth: "800px",
      margin: "0 auto",
      marginBottom: token.spacing.xl,
      ["& img"]: {
        maxWidth: "100%",
        maxHeight: "500px",
        marginLeft: "auto",
        marginRight: "auto"
      }
    }
  }).build();
};
const createHeadline = (props) => {
  const { headline, isThemeDark, isThemeMaryland } = props;
  const finalIsThemeDark = isThemeDark || isThemeMaryland;
  if (!headline) return null;
  return new ElementBuilder(headline).styled(
    Styles.typography.campaign.compose("large", {
      theme: theme.fontColor(finalIsThemeDark)
    })
  ).withStyles({
    element: {
      textTransform: "uppercase"
    },
    siblingAfter: {
      marginTop: token.spacing.sm
    }
  }).build();
};
const createText = (props) => {
  const { isThemeDark, isThemeMaryland } = props;
  const textLockupElement = createTextLockupLarge({
    ribbon: props.eyebrow,
    headlineComposite: createHeadline(props),
    textLargest: props.text,
    actions: props.actions,
    isThemeDark: isThemeDark || isThemeMaryland || false
  });
  const textContent = new ElementBuilder().withClassName("umd-hero-logo__text-content").withChild(textLockupElement).withStyles({
    element: {
      [`& .${elementStyles.text.rich.simpleLargest.className}`]: {
        color: token.color.gray.dark
      }
    }
  }).build();
  return new ElementBuilder().withClassName("umd-hero-logo__text").withChild(textContent).withStyles({
    element: {
      display: "flex",
      justifyContent: "center",
      textAlign: "center"
    }
  }).build();
};
const makeLock = (props) => {
  const asset = createAsset(props);
  const text = createText(props);
  const builder = new ElementBuilder().styled(
    Styles.layout.space.horizontal.small
  );
  if (asset) {
    builder.withChild(asset);
  }
  builder.withChild(text);
  return builder.build();
};
const createCompositeHeroLogo = (props) => {
  const { isThemeDark } = props;
  const container = new ElementBuilder().withClassName("umd-hero-logo__container").withChild(makeLock(props)).withStyles({
    element: {
      padding: `${token.spacing["5xl"]} 0 ${token.spacing.lg}`,
      backgroundColor: getBackgroundColor(props),
      // Dark them should have additonal padding at the bottom
      [`@container (${token.media.queries.desktop.min})`]: {
        ...isThemeDark && {
          paddingBottom: `${token.spacing["5xl"]}`
        }
      }
    }
  }).build();
  return new ElementBuilder().withClassName("umd-hero-logo").withChild(container).withStyles({
    element: {
      containerType: "inline-size"
    }
  }).build();
};
export {
  createCompositeHeroLogo
};
//# sourceMappingURL=logo.js.map
